import React from "react";
import { PackSlipHeaderContainer } from "./packSlipHeader.style";

const PackSlipHeader = ({ toNumber, from, to }) => {
  return (
    <PackSlipHeaderContainer>
      <div className="rowItem">
        <div className="label">TO No. </div>
        <div className="label">:</div>
        <div className="value">{toNumber}</div>
      </div>
      <div className="rowItem">
        <div className="label">From </div>
        <div className="label">:</div>
        <div className="value">{from}</div>
      </div>
      <div className="rowItem">
        <div className="label">To </div>
        <div className="label">:</div>
        <div className="value">{to}</div>
      </div>
    </PackSlipHeaderContainer>
  );
};

export default PackSlipHeader;
